import { gql, TypedDocumentNode } from "@apollo/client";

import { ManagedUser, QueryManagedUserArgs } from "types/generated";

import { UserPersonalApiKey } from "./types";

type GetUserPersonalApiKeysData = {
  managedUser: Pick<ManagedUser, "id"> & { personalApiKeys: UserPersonalApiKey[] };
};

export const GET_USER_PERSONAL_API_KEYS: TypedDocumentNode<
  GetUserPersonalApiKeysData,
  QueryManagedUserArgs
> = gql`
  query GetUserPersonalApiKeys($id: ID!) {
    managedUser(id: $id) {
      id
      personalApiKeys {
        id
        name
        type
        owner
        createdAt
        expiresAt
        lastUsedAt
        disabled
        disabledAt
        disabledReason
      }
    }
  }
`;
